import { createFileRoute } from "@tanstack/react-router";

import { BandLink } from "@/components/site/ctas";
import { Consolidation } from "@/components/site/home-sections";
import { Reveal } from "@/components/site/motion";
import { getDict, href, type Lang } from "@/content/site";

export const Route = createFileRoute("/$lang/manufacturing-network")({
  loader: ({ params }) => ({ lang: params.lang as Lang }),
  head: ({ loaderData }) => {
    const t = getDict(loaderData?.lang ?? "en");
    return { meta: [{ title: `${t.network.title} · insidermark` }, { name: "description", content: t.network.intro }] };
  },
  component: Page,
});

function Page() {
  const { lang } = Route.useLoaderData();
  const t = getDict(lang);
  const n = t.network;
  return (
    <main>
      <header className="im-page-head">
        <div className="im-wrap">
          <Reveal>
            <h1 className="im-display">{n.title}</h1>
            <p className="im-body-text mt-5">{n.intro}</p>
          </Reveal>
        </div>
      </header>

      <section className="im-section im-section--tight">
        <div className="im-wrap">
          <div className="im-partners">
            {n.partners.map((p, i) => {
              const d = t.divisions.find((x) => x.slug === p.division);
              return (
                <Reveal className="im-partner" key={p.area}>
                  <div>
                    <b>PARTNER 0{i + 1}</b>
                    <div className="im-mono mt-2">{p.since}</div>
                  </div>
                  <div>
                    <strong>{p.area}</strong>
                    <span>{p.capacity}</span>
                  </div>
                  <div>
                    <span>{p.certs}</span>
                    {d ? (
                      <div className="mt-3">
                        <BandLink to={href(lang, `/divisions/${d.slug}`)} meta={`DIV ${d.code}`}>
                          {d.name}
                        </BandLink>
                      </div>
                    ) : null}
                  </div>
                </Reveal>
              );
            })}
          </div>
          <p className="im-mono mt-8 max-w-[70ch]">{n.rule}</p>
        </div>
      </section>

      <Consolidation t={t} />

      <section className="im-section im-section--tight">
        <div className="im-wrap">
          <p className="im-body-text">{n.corridor}</p>
        </div>
      </section>
    </main>
  );
}
